import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { rootState, AppDispatch } from '../index'

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<rootState> = useSelector
